module.exports = __webpack_public_path__ + "media/images/ready/icon-gear-506178e047413e1e8dedafce536274dc.svg";